module.exports = __webpack_public_path__ + "img/store_image.706e9807.png";